module.exports = __webpack_public_path__ + "static/img/pico15.c568f4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico15.png
// module id = I5UZ
// module chunks = 0